import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { IconButton, Stack, TooltipDelay, TooltipHost } from '@fluentui/react';
import * as PropTypes from 'prop-types';
export const AppReviewCommentItemToolbar = ({ onDeleteToggle, onEditToggle, className, isEditing = false }, context)=>{
    const icons = {
        delete: {
            iconName: 'Delete'
        },
        edit: {
            iconName: 'Edit'
        }
    };
    const tooltipCalloutProps = {
        gapSpace: 5
    };
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsxs(Stack, {
            horizontal: true,
            tokens: {
                childrenGap: 4
            },
            children: [
                /*#__PURE__*/ _jsx(TooltipHost, {
                    content: context.loc('ReviewItem_CommentSection_Comment_Edit_Button_Tooltip', 'Edit your comment'),
                    calloutProps: tooltipCalloutProps,
                    delay: TooltipDelay.zero,
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        iconProps: icons.edit,
                        onClick: ()=>{
                            !isEditing && onEditToggle();
                        },
                        checked: isEditing,
                        text: context.loc('ReviewItem_CommentSection_Comment_Edit_Button_Label', 'Edit'),
                        ariaLabel: context.loc('ReviewItem_CommentSection_Comment_Edit_Button_Label', 'Edit')
                    })
                }),
                /*#__PURE__*/ _jsx(TooltipHost, {
                    content: context.loc('ReviewItem_CommentSection_Comment_Delete_Button_Tooltip', 'Delete your comment'),
                    calloutProps: tooltipCalloutProps,
                    delay: TooltipDelay.zero,
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        iconProps: icons.delete,
                        onClick: onDeleteToggle,
                        text: context.loc('ReviewItem_CommentSection_Comment_Delete_Button_Label', 'Delete'),
                        ariaLabel: context.loc('ReviewItem_CommentSection_Comment_Delete_Button_Label', 'Delete')
                    })
                })
            ]
        })
    });
};
AppReviewCommentItemToolbar.contextTypes = {
    loc: PropTypes.func
};
